import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-flex;\n\tvertical-align: baseline;\n\twidth: auto;\n\n\t", "\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\tbox-shadow: ", ";\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\n\t&:hover,\n\t&:active {\n\t\tborder-color: ", ";\n\t}\n\n\t&:focus,\n\t&[data-focused='true'] {\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground-color: transparent;\n\n\t&:hover,\n\t&:active,\n\t&:focus,\n\t&[data-focused='true'] {\n\t\t", ";\n\t}\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", ";\n\tbox-shadow: ", ";\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\t", ";\n\tborder: 1px solid;\n\tborder-color: ", ";\n\tbox-shadow: ", ";\n\tdisplay: flex;\n\tflex: 1;\n\tfont-family: ", ";\n\tfont-size: ", ";\n\toutline: none;\n\tpadding: 0 8px;\n\tposition: relative;\n\ttransition: border-color ", " ease;\n\twidth: 100%;\n\n\t&[disabled] {\n\t\topacity: 0.6;\n\t}\n\n\t&:hover {\n\t\tborder-color: ", ";\n\t}\n\n\t&:focus,\n\t&[data-focused='true'] {\n\t\tborder-color: ", ";\n\t\tbox-shadow: ", ";\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var BaseField = css(_templateObject(), ui.background.control, ui.borderRadius.round, ui.get('controlBorderColor'), ui.get('controlBoxShadow'), ui.get('fontFamily'), ui.get('fontSize'), ui.get('transitionDurationFastest'), ui.get('controlBorderColorHover'), ui.color.admin, ui.get('controlBoxShadowFocus'));
export var clickable = css(_templateObject2());
export var focus = css(_templateObject3(), ui.color.admin, ui.get('controlBoxShadowFocus'), ui.color.admin);
export var subtle = css(_templateObject4(), ui.background.control);
export var error = css(_templateObject5(), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColor'), ui.get('controlDestructiveBorderColorFocus'), ui.get('controlDestructiveBoxShadowFocus'));
export var errorFocus = css(_templateObject6(), ui.get('controlDestructiveBorderColorFocus'), ui.get('controlDestructiveBoxShadowFocus'), ui.get('controlDestructiveBorderColorFocus'));
export var inline = css(_templateObject7(), ui.browsers.safari("\n\t\t\tvertical-align: middle;\n\t"));